import React from 'react'
import { reduxForm, Field } from 'redux-form'

import WrappedInput from '../../Shared/Forms/WrappedInput'
import Button from '../../Shared/Button'
import Card from '../../Shared/LegacyCard'
import FormError from '../../Shared/Forms/FormError'

import styles from '../Auth.module.css'

const FORM_NAME = 'resetPassword'

const validate = data => {
  const errors = {}

  if (!data.password) {
    errors.password = 'Required'
  }

  return errors
}

const Form = function LoginForm({ handleSubmit, submitting, error }) {
  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <div className={styles.inputs}>
          <Field
            name="password"
            placeholder="New Password"
            type="password"
            component={WrappedInput}
          />
        </div>
        <Button primary block loading={submitting}>
          Change Password
        </Button>
        {error && <FormError>{error}</FormError>}
      </Card>
    </form>
  )
}

export default reduxForm({
  form: FORM_NAME,
  validate,
})(Form)
